import fetchHelper from '../utils/fetchHelper.js';

// Updated to handle the new response structure introduced by sendSuccess
export const auth = {
    login: (user) => fetchHelper.post('/auth/login', user).then((res) => res.result),
    loginGoogle: () => fetchHelper.get('/auth/google'),
    loginMicrosoft: () => fetchHelper.get('/auth/azure'),
    logout: (data) => fetchHelper.delete('/auth/remove-remember-me', data),
    getUserByCookie: () => fetchHelper.get('/auth/me').then((res) => res.result),
};

export const user = {
    getById: (id) => fetchHelper.get(`/users/${id}`).then((res) => res.result),
    updateProfile: (profile) => fetchHelper.put(`/users/profile/${profile.id}`, profile).then((res) => res.result),
    addUser: (profile) => fetchHelper.post(`/users`, profile).then((res) => res.result),
    updateUser: (id, profile) => fetchHelper.put(`/users/${id}`, profile).then((res) => res.result),
    deleteUser: (id) => fetchHelper.delete(`/users/${id}`).then((res) => res.result),
    getBalanceHistory: (userId, page, perPage) =>
        fetchHelper.get(`/users/balance/history/${userId}?page=${page}&perPage=${perPage}`).then((res) => res.result),
    updateBalance: (userId, data) => fetchHelper.put(`/users/balance/update/${userId}`, data).then((res) => res.result),
    getTeamEvents: () => fetchHelper.get('/users/teams/events').then((res) => res.result),
    getRemoteCalendar: (userId) => fetchHelper.get(`/remote-user-calendar/${userId}`).then((res) => res.result),
    getUsers: (page, perPage, query) =>
        fetchHelper.get(`/users?page=${page}&perPage=${perPage}${query}`).then((res) => res.result),
    getUserStatistics: (page, perPage, query) =>
        fetchHelper
            .get(`statistics/users-with-vacations?page=${page}&perPage=${perPage}${query}`)
            .then((res) => res.result),
    getWithPagination: (page, perPage, query) =>
        fetchHelper.get(`/users/page?page=${page}&perPage=${perPage}${query}`).then((res) => res.result),
    getPermissionToCreateEvents: () => fetchHelper.get('/users/events/enabled').then((res) => res.result),
    getPermissions: () => fetchHelper.get('/users/permissions').then((res) => res.result),
};

export const vacations = {
    get: (page, perPage) => fetchHelper.get(`/vacations?page=${page}&perPage=${perPage}`).then((res) => res.result),
    create: (data) => fetchHelper.post('/vacations', data).then((res) => res.result),
    update: (id, data) => fetchHelper.put('/vacations/' + id, data).then((res) => res.result),
    remove: (id) => fetchHelper.delete('/vacations/' + id).then((res) => res.result),
    approve: (id) => fetchHelper.post(`/vacations/${id}/approve`).then((res) => res.result),
    deny: (id) => fetchHelper.put(`/vacations/${id}/deny`).then((res) => res.result),
    getBalance: (id) => fetchHelper.get('/vacations/balance/' + id).then((res) => res.result),
};

export const sickLeaves = {
    getAll: () => fetchHelper.get('/my-working/sick-leaves').then((res) => res.result),
    get: (page, perPage, query) =>
        fetchHelper.get(`/statistics/sick-leaves?page=${page}&perPage=${perPage}${query}`).then((res) => res.result),
    create: (data) => fetchHelper.post('/my-working/sick-leaves', data).then((res) => res.result),
    update: (data, id) => fetchHelper.put('/my-working/sick-leaves/' + id, data).then((res) => res.result),
    delete: (id) => fetchHelper.delete('/my-working/sick-leaves/' + id).then((res) => res.result),
};

export const workingDay = {
    getAll: () => fetchHelper.get('/my-working/working-days').then((res) => res.result),
    create: (data) => fetchHelper.post('/my-working/working-days', data).then((res) => res.result),
    update: (data, id) => fetchHelper.put('/my-working/working-days/' + id, data).then((res) => res.result),
    delete: (id) => fetchHelper.delete('/my-working/working-days/' + id).then((res) => res.result),
    getStats: (teamId, startDate, endDate) =>
        fetchHelper
            .get(`/my-working/working-days/statistics?teamId=${teamId}&startDate=${startDate}&endDate=${endDate}`)
            .then((res) => res.result),
};

export const holidays = {
    getAll: () => fetchHelper.get('/holidays').then((res) => res.result),
    get: (page, perPage, query) =>
        fetchHelper.get(`/holidays?&page=${page}&perPage=${perPage}${query}`).then((res) => res.result),
    create: (data) => fetchHelper.post('/holidays', data).then((res) => res.result),
    update: (data, id) => fetchHelper.put(`/holidays/${id}`, data).then((res) => res.result),
    delete: (id) => fetchHelper.delete(`/holidays/${id}`).then((res) => res.result),
};

export const birthdays = {
    getAll: () => fetchHelper.get('/birthdays').then((res) => res.result),
};

export const remoteCalendar = {
    get: (page, perPage, query) =>
        fetchHelper.get(`/remote-calendar?page=${page}&perPage=${perPage}${query}`).then((res) => res.result),
    create: (data) => fetchHelper.post('/remote-calendar', data).then((res) => res.result),
    update: (id, data) => fetchHelper.put(`/remote-calendar/${id}`, data).then((res) => res.result),
    delete: (id) => fetchHelper.delete(`/remote-calendar/${id}`).then((res) => res.result),
};

export const resetPassword = {
    sendEmail: (data) => fetchHelper.post('/auth/reset', data).then((res) => res.result),
    reset: (data, token) => fetchHelper.post('/auth/set-new-password/' + token, data).then((res) => res.result),
};

export const workingTime = {
    getAll: (page, perPage) => fetchHelper.get(`/overtimes?page=${page}&perPage=${perPage}`).then((res) => res.result),
    get: (page, perPage, query) =>
        fetchHelper.get(`/statistics/working-times?page=${page}&perPage=${perPage}${query}`).then((res) => res.result),
    create: (data) => fetchHelper.post('/overtimes', data).then((res) => res.result),
    update: (data, id) => fetchHelper.put('/overtimes/' + id, data).then((res) => res.result),
    delete: (id) => fetchHelper.delete('/overtimes/' + id).then((res) => res.result),
    approve: (id) => fetchHelper.post(`/overtimes/${id}/approve`).then((res) => res.result),
    deny: (id) => fetchHelper.put(`/overtimes/${id}/deny`).then((res) => res.result),
};

// fetching pending vacation/overtime requests
export const pendingRequests = {
    get: (page, perPage) =>
        fetchHelper.get(`/pastimes/pending?page=${page}&perPage=${perPage}`).then((res) => res.result),
};

export const team = {
    getAll: () => fetchHelper.get('/teams').then((res) => res.result),
    get: (page, perPage, query) =>
        fetchHelper.get(`/teams?page=${page}&perPage=${perPage}${query}`).then((res) => res.result),
    create: (data) => fetchHelper.post('/teams', data).then((res) => res.result),
    update: (data, id) => fetchHelper.put('/teams/' + id, data).then((res) => res.result),
    delete: (id) => fetchHelper.delete('/teams/' + id).then((res) => res.result),
    getById: (id) => fetchHelper.get(`/teams/${id}`).then((res) => res.result),
    getTeamEmployees: (id, page, perPage, query) =>
        fetchHelper.get(`/teams/${id}/users?page=${page}&perPage=${perPage}${query}`).then((res) => res.result),
    getNonIncludedEmployees: (teamId) =>
        fetchHelper.get(`/teams/${teamId}/users/search?name=`).then((res) => res.result),
    attachEmployee: (teamId, employeeId) =>
        fetchHelper.post(`/teams/${teamId}/users/page/${employeeId}`).then((res) => res.result),
    updateEmployee: (teamId, employeeId, data) =>
        fetchHelper.put(`/teams/${teamId}/users/${employeeId}`, data).then((res) => res.result),
    excludeEmployee: (teamId, employeeId, autoApprove = false) =>
        fetchHelper.delete(`/teams/${teamId}/users/${employeeId}?autoApprove=${autoApprove}`).then((res) => res.result),
};

export const timeSheet = {
    get: (startDate, endDate) =>
        fetchHelper.get(`/statistics/time-sheet?startDate=${startDate}&endDate=${endDate}`).then((res) => res.result),
    post: ({ teamId, hours, date }) =>
        fetchHelper.post(`/changed-working-hours/${teamId}`, { hours, date }).then((res) => res.result),
};

export const date = {
    get: () => fetchHelper.get('/date'),
    reset: () => fetchHelper.get('/date/reset'),
    change: (data) => fetchHelper.post('/date/change', data).then((res) => res.result),
    getRewind: (id) => fetchHelper.get(`/date/getRewind/${id}`).then((res) => res.result),
    getEmails: () => fetchHelper.get(`/date/tempMails`).then((res) => res.result),
};

export const settings = {
    get: (page, perPage) => fetchHelper.get(`/settings/all?page=${page}&perPage=${perPage}`).then((res) => res.result),
    create: (data) => fetchHelper.post('/settings', data).then((res) => res.result),
    update: (data) => fetchHelper.put(`/settings`, data).then((res) => res.result),
    delete: (key) => fetchHelper.delete(`/settings/${key}`).then((res) => res.result),
    getEmailsTemplates: () => fetchHelper.get(`/settings/email/templates`).then((res) => res.result),
    updateEmailTemplate: (data) => fetchHelper.put(`/settings/email/templates`, data).then((res) => res.result),
};

export const overtime = {
    get: (query) => fetchHelper.get(`/statistics/overtimes?${query}`).then((res) => res.result),
};

export const linkedGoogleCalendar = {
    getAuthUrl: () => fetchHelper.get('/google/oauth2/url').then((res) => res.result.url),
    getLinkedCalendars: () => fetchHelper.get('/user-linked-calendars/my').then((res) => res.result),
    removeLinkedCalendar: (id) => fetchHelper.delete(`/user-linked-calendars/${id}`).then((res) => res.result),
};
